export default __webpack_public_path__ + "static/media/debate_8.7e1f0309.JPG";